module.exports = __webpack_public_path__ + "img/yangDetail4.31d56936.jpg";